import React, { Fragment, useState } from "react";
import { Dialog, Tab, Transition } from "@headlessui/react";

import Card from "components/Card";
import RepairEstimateReport from "img/rer.png";

export default function WhyUs() {
  const [isModernInspectionOpen, setIsModernInspectionOpen] = useState(false);
  const [isInsuredDialogOpen, setIsInsuredDialogOpen] = useState(false);

  return (
    <div className="my-20">
      <p
        className="leading-snug tracking-wider text-center text-4xl font-extrabold"
        role="heading"
        aria-level="1"
      >
        Why Core Inspection?
      </p>

      <div className="flex flex-col lg:flex-row items-center justify-center">
        <Card
          backgroundImage="bg-vetOwnedCard"
          text="Veteran Owned"
          alt="Veteran owned"
          style={{ cursor: "default" }}
        ></Card>

        <Card
          backgroundImage="bg-sampleReport"
          text="Comprehensive Report"
          alt="View a sample report"
          onClick={() =>
            window.open(
              "https://www.homegauge.com/report/14539356/FullReportForUpload.html",
              "_blank"
            )
          }
        ></Card>

        <Card
          backgroundImage="bg-drone"
          text="Modern Inspection"
          alt="Modern inspection"
          onClick={() => setIsModernInspectionOpen(true)}
        ></Card>
        <Transition appear show={isModernInspectionOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsModernInspectionOpen(false)}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block w-full max-w-4xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded">
                  <Dialog.Title className="mb-2 text-2xl font-medium leading-6 text-gray-900">
                    You're Getting the Latest and Greatest
                  </Dialog.Title>

                  <div className="w-full max-w-lg px-2 py-4 sm:px-0">
                    <Tab.Group>
                      <Tab.List className="flex p-1 space-x-3">
                        <Tab
                          className={
                            "w-full py-2.5 text-lg leading-5 text-ciGreen-poppin rounded focus:outline-none focus:ring-2 ring-offset-2 ring-offset-ciGreen-poppin ring-white ring-opacity-60 bg-white shadow hover:text-ciGreen-medium"
                          }
                        >
                          Repair Estimates
                        </Tab>
                        <Tab
                          className={
                            "w-full py-2.5 text-lg leading-5 text-ciGreen-poppin rounded focus:outline-none focus:ring-2 ring-offset-2 ring-offset-ciGreen-poppin ring-white ring-opacity-60 bg-white shadow hover:text-ciGreen-medium"
                          }
                        >
                          Drones
                        </Tab>
                      </Tab.List>
                      <Tab.Panels className="mt-2">
                        <Tab.Panel className={""}>
                          <a
                            href="https://porch.com/repair-estimate/sample/report/"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Porch"
                          >
                            <p className="text-lg text-blue-600 my-4">
                              See a sample Repair Estimate Report online.
                            </p>
                          </a>
                          <p>
                            We've partnered with an industry leader, Porch, to
                            provide you with price quotes for potential problems
                            seen during your inspection.
                          </p>

                          <ul className="my-3 ml-7 list-inside list-disc text-md font-medium">
                            <li>See a breakdown by contractor type</li>
                            <li>Make an informed offer with repair costs</li>
                          </ul>
                          <img
                            src={RepairEstimateReport}
                            alt="Sample repair estimate report"
                            className="border-2 border-ciGreen rounded p-3"
                          />
                        </Tab.Panel>
                      </Tab.Panels>
                    </Tab.Group>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                      onClick={() => setIsModernInspectionOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>

        <Card
          backgroundImage="bg-certified"
          text="Insured & InterNACHI Certified"
          alt="Insured and InterNACHI certified"
          onClick={() => setIsInsuredDialogOpen(true)}
        ></Card>
        <Transition appear show={isInsuredDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsInsuredDialogOpen(false)}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded">
                  <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
                    Rest Assured - We're Trained & Insured
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Our team is highly trained and your investment in us is
                      fully insured. Check out our warranties.
                    </p>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                      onClick={() => setIsInsuredDialogOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    </div>
  );
}
